module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edi-main main-page",
    style: ({
      'height': _vm.deviceHeight
    })
  }, [_c('transition', {
    attrs: {
      "name": _vm.transitionName,
      "mode": "out-in"
    }
  }, [_c('router-view', {
    attrs: {
      "keep-alive": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "foot bottom-footer"
  }, [_c('ul', [_c('li', [_c('router-link', {
    staticClass: "tabs-home",
    attrs: {
      "to": "/main/home",
      "replace": ""
    }
  }, [_vm._v("首页")])], 1), _c('li', [_c('router-link', {
    staticClass: "tabs-reciept",
    attrs: {
      "to": "/main/reciept",
      "replace": ""
    }
  }, [_vm._v("单据")])], 1), _c('li', [_c('router-link', {
    staticClass: "tabs-account",
    attrs: {
      "to": "/main/my",
      "replace": ""
    }
  }, [_vm._v("我的")])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8bf78a64!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Main.vue
// module id = 602
// module chunks = 1